import { queryKeyFn } from "./estabrookContext";

export const createRegionsQueryKey = (
  limit: number = 100,
  page: number = 1,
) => {
  return queryKeyFn({
    path: "/api/v2/admin/regions",
    operationId: "adminRegionV2ControllerGetRegions",
    variables: {
      queryParams: {
        limit,
        page,
      },
    },
  });
};

export const createLocationsQueryKey = (
  queryParams: Record<string, any> = {},
) => {
  return queryKeyFn({
    path: "/api/v2/admin/locations",
    operationId: "adminLocationV2ControllerGetAllLocations",
    variables: {
      queryParams,
    },
  });
};

export const createRoutesQueryKey = (
  date: string,
  includeLocations: boolean = true,
  orderStatuses: ("skipped" | "regular" | "delayed" | "urgent")[] = [],
) => {
  return queryKeyFn({
    path: "/api/v2/admin/routes",
    operationId: "adminRouteV2ControllerGetRoutes",
    variables: {
      queryParams: {
        date,
        includeLocations,
        orderStatuses,
      },
    },
  });
};

// Helper functions for broad invalidation (invalidate ALL queries for an operation)
export const createRegionsInvalidationPredicate = () => ({
  predicate: (query: any) => {
    const queryKey = query.queryKey as any[];
    return checkQueryKey(queryKey, "api/v2/admin/regions");
  },
});

export const createLocationsInvalidationPredicate = () => ({
  predicate: (query: any) => {
    const queryKey = query.queryKey as any[];
    return checkQueryKey(queryKey, "api/v2/admin/locations");
  },
});

export const createRoutesInvalidationPredicate = () => ({
  predicate: (query: any) => {
    const queryKey = query.queryKey as any[];
    return checkQueryKey(queryKey, "api/v2/admin/routes");
  },
});

export const createRegionsOptimisticQueryKey = (
  queryParams: Record<string, any> = {},
) => {
  return queryKeyFn({
    path: "/api/v2/admin/regions",
    operationId: "adminRegionV2ControllerGetRegions",
    variables: {
      queryParams,
    },
  });
};

export const createLocationsOptimisticQueryKey = (
  queryParams: Record<string, any> = {},
) => {
  return queryKeyFn({
    path: "/api/v2/admin/locations",
    operationId: "adminLocationV2ControllerGetAllLocations",
    variables: {
      queryParams,
    },
  });
};

export const createRoutesOptimisticQueryKey = (
  queryParams: Record<string, any> = {},
) => {
  return queryKeyFn({
    path: "/api/v2/admin/routes",
    operationId: "adminRouteV2ControllerGetRoutes",
    variables: {
      queryParams,
    },
  });
};

export const createGlobalRouteNotificationsQueryKey = (date: string) => {
  return queryKeyFn({
    path: "/api/v2/admin/routes/date/{date}/notifications",
    operationId: "adminRouteV2ControllerGetRouteNotificationsPerDate",
    variables: {
      pathParams: {
        date,
      },
    },
  });
};

export const createCustomerLocationsQueryKey = (customerId: string) => {
  return queryKeyFn({
    path: "/api/v1/admin/customers/{customerId}/locations",
    operationId: "adminLocationCustomerControllerGetAll",
    variables: {
      pathParams: { customerId },
    },
  });
};

export const checkQueryKey = (queryKey: any[], endpoint: string) => {
  if (!Array.isArray(queryKey)) return false;

  const endpointParts = endpoint.split("/");
  return (
    Array.isArray(endpointParts) &&
    queryKey.length >= endpointParts.length &&
    endpointParts.every((part, idx) => {
      // Handle dynamic path parameters like {date}, {id}, etc.
      if (part.startsWith("{") && part.endsWith("}")) {
        // Dynamic segment - any value is acceptable at this position
        return true;
      }
      return queryKey[idx] === part;
    })
  );
};
